import { render, staticRenderFns } from "./AuthenticatedLayout.vue?vue&type=template&id=4b5ac425&"
import script from "./AuthenticatedLayout.vue?vue&type=script&lang=ts&"
export * from "./AuthenticatedLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticatedLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
